import React, { useState } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Grid, Container } from "semantic-ui-react";
import { useAuth } from "../../../AuthenticationStore";
import { UserModal } from "./UserModal";

export const Users = () => {
  const { platformUserService } = useAuth();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [modalUser, setModalUser] = useState(false);
  const [editData, setEditData] = useState({});

  const columns = [
    {
      Header: "Nombre",
      accessor: "userName"
    },
    {
      Header: "Correo electrónico",
      accessor: "email"
    },
    {
      Header: "Teléfono",
      accessor: "mobile",
      minWidth: 40
    },
    {
      Header: "Rol",
      accessor: d => {
        switch (d.userRole) {
          case 1:
            return "CTO";
          case 2:
            return "CEO";
          case 3:
            return "CMO";
          default:
            return "Sin estado";
        }
      },
      id: "userRole",
      minWidth: 20
    },
    {
      Header: "Estado",
      accessor: d => {
        switch (d.userState) {
          case 0:
            return "Activo";
          case 1:
            return "Inactivo";
          case 2:
            return "Demo";
          default:
            return "Sin estado";
        }
      },
      id: "userState",
      minWidth: 30
    },
    {
      Cell: props => (
        <div className="btn-group" role="group" aria-label="">
          <button
            className="btn btn-primary"
            onClick={() => openModalEdit(props.original)}
          >
            <i className="mdi mdi-account-edit"></i>
          </button>
          {props.original.userState === 0 ? (
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => changeStatusteUser(props.original, 1)}
            >
              <i className="mdi mdi mdi-cancel"></i>
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => changeStatusteUser(props.original, 0)}
            >
              <i className="mdi mdi mdi-account-check"></i>
            </button>
          )}
        </div>
      ),
      Header: "Acciones",
      accessor: "platformUserId",
      minWidth: 50
    }
  ];

  const openModalEdit = data => {
    setModalUser(true);
    setEditData(data);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await platformUserService.getPlatformUsers();
      setData(response.object);
      // eslint-disable-next-line no-console
      console.log(response);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setLoading(false);
  };

  setTimeout(() => setLoading(false), 3000);

  const changeStatusteUser = async (user, status) => {
    setLoading(true);
    try {
      let response;

      if (status === 1) {
        response = await platformUserService.inactivatePlatformUser(
          user.platformUserId
        );
      } else {
        response = await platformUserService.activatePlatformUser(
          user.platformUserId
        );
      }

      // eslint-disable-next-line no-console
      console.log(response);
      fetchData();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <Container>
      <UserModal
        show={modalUser}
        handleClose={() => {
          fetchData();
          setModalUser(false);
        }}
        data={editData}
      />
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <ReactTable
              manual
              defaultPageSize={5}
              data={data}
              onFetchData={fetchData}
              loading={loading}
              minRows={1}
              columns={columns}
              previousText="Anterior"
              nextText="Siguiente"
              pageText="página"
              ofText="de"
              rowsText="registros"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};
